export default "__VITE_ASSET__DQ4_3uel__"